export const formTranslation = () => {
	// if html lang attribue is en-US exit this script
	if (document.documentElement.lang === 'en-US') {
		return;
	}

	// if .pcp_name element is not present exit this script
	if (!document.querySelector('.pcp_name')) {
		return;
	}

	// console.log('formTranslation');

	var requiredMark =
		'<span class="gfield_required"><span class="gfield_required gfield_required_asterisk">*</span></span>';

	// Parse the JSON data from the script tag
	var formData = JSON.parse(document.getElementById('pcp-form-labels').textContent);

	// Function to replace text content for form labels and descriptions
	function replaceTextContent(selector, newText) {
		var elements = document.querySelectorAll(selector);
		elements.forEach(function (element) {
			// replace the text content with new text html
			element.innerHTML = newText;
		});
	}

	// Function to update select options
	function updateSelectOptions(selector, newOptions) {
		var selectElement = document.querySelector(selector);
		if (selectElement) {
			var options = newOptions.split('\n'); // Split by new line

			// loop through existing options and update the text content with the new options
			var existingOptions = selectElement.querySelectorAll('option');
			existingOptions.forEach(function (option, index) {
				option.textContent = options[index];
			});
		}
	}

	// Function to update the first option of a select element
	function updateFirstOption(selector, newText) {
		var selectElement = document.querySelector(selector);
		if (selectElement) {
			selectElement.querySelector('option').textContent = newText;
		}
	}

	// Replace form labels and descriptions with data from JSON
	replaceTextContent('.pcp_name .name_first .gform-field-label--type-sub', formData.first_name);
	replaceTextContent('.pcp_name .name_last .gform-field-label--type-sub', formData.first_name);
	replaceTextContent('.pcp_email .gform-field-label', formData.email + requiredMark);
	replaceTextContent('.pcp_job_title .gform-field-label', formData.job_title);
	replaceTextContent('.pcp_organization .gform-field-label', formData.organization);
	replaceTextContent('.pcp_organization_website .gform-field-label', formData.organization_website);
	replaceTextContent('.pcp_region .gform-field-label', formData.location_region + requiredMark);
	replaceTextContent('.pcp_country .gform-field-label', formData.location_countries + requiredMark);
	replaceTextContent(
		'.pcp_preferred_lang .gform-field-label',
		formData.language_preference_for_public_comment + requiredMark,
	);
	replaceTextContent('.pcp_full_comment .gform-field-label', formData.provide_the_full_comment);
	replaceTextContent('.pcp_full_comment .gfield_description', formData.provide_the_full_text_of_your_comment);
	replaceTextContent('.pcp_document .gform-field-label', formData.upload_document);
	replaceTextContent('.pcp_document .gfield_description', formData.upload_document_instructions);
	replaceTextContent('.pcp_consent_publish .gform-field-label', formData.consent_publish + requiredMark);
	replaceTextContent('.pcp_consent_publish .gfield_description', formData.consent_publish_instructions);
	replaceTextContent('.pcp_consent_name .gform-field-label', formData.consent_name + requiredMark);
	replaceTextContent('.pcp_consent_org .gform-field-label', formData.consent_organization + requiredMark);
	replaceTextContent('.pcp_consent_email .gform-field-label', formData.consent_contact + requiredMark);
	replaceTextContent('.pcp_special_category_data .gform-field-label', formData.special_category_data + requiredMark);
	replaceTextContent('.pcp_special_category_data .gfield_consent_label', formData.special_category_data_instructions);
	replaceTextContent('.pcp_privacy .gform-field-label', formData.privacy_notice + requiredMark);
	replaceTextContent('.pcp_privacy .gfield_consent_label', formData.privacy_notice_instructions);
	replaceTextContent('.gform_button[type="submit"]', formData.submit_button);
	replaceTextContent('.gform_confirmation_message', formData.confirmation_message);

	// Update select options
	updateSelectOptions('.pcp_region .gfield_select', formData.location_region_choices);
	updateSelectOptions('.pcp_country .gfield_select', formData.location_country_choices);
	updateSelectOptions('.pcp_consent_publish .gfield_select', formData.consent_publish_choices);
	updateSelectOptions('.pcp_consent_name .gfield_select', formData.consent_name_choices);
	updateSelectOptions('.pcp_consent_org .gfield_select', formData.consent_organization_choices);
	updateSelectOptions('.pcp_consent_email .gfield_select', formData.consent_contact_choices);

	// Update first option
	updateFirstOption('.pcp_preferred_lang .gfield_select', formData.language_preference_select);
};
